/// <reference path="../../../../WebUI/typings/tsd.d.ts" />

import Rest = require("../../Generated/RestClient");
import { readCookie } from "../../../../Intercom.ReactUI/Utils/Cookies";

/**
 * General Authentication helpers.
 */
export class AuthenticationUtility {
    /**
      * Replace the signed in user auth token and "bind" the token to the ajax rest headers.
      */
    public static bindAzureAccessToken(signedInUser: Rest.AuthData, authenticationToken: string, fixTenantId: boolean = false): void {
        if (!authenticationToken) {
            throw new Error("authenticationToken must be defined.");
        }
        if (!signedInUser) {
            throw new Error("signedInUser must be defined.");
        }

        signedInUser.AzureToken = authenticationToken;
        const headers = fixTenantId ? { "X-BF-OAUTH-TOKEN": authenticationToken, "X-BF-TenantId": signedInUser.TenantId } 
            : { "X-BF-OAUTH-TOKEN": authenticationToken };
        Rest.ajaxHeaders = _.extend(Rest.ajaxHeaders || {}, headers);
    }

    /**
     * Copy the CSRF token in the cookie to the ajax rest headers.
     * @returns true if there was a token to copy otherwise false.
     */
    public static setRequestVerificationHeader(): boolean {
        const requestVerificationToken = this.getCsrfToken();
        if (requestVerificationToken) {
            Rest.ajaxHeaders = _.extend(Rest.ajaxHeaders || {}, { 'X-Csrf-Token': requestVerificationToken });
        }

        return !!requestVerificationToken;
    }

    /*
     * Gets the CSRF form token from the client-accessible cookie.
     */
    public static getCsrfToken(): string {
        return readCookie('Csrf-Token');
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Utility/AuthenticationUtility.ts